import { InterviewRetakeMode } from "@repo/app-types/entities/jobType";
import {
  PermissionActions,
  PermissionSubjects,
} from "@repo/app-types/entities/teammatePermissions";
import { SaveAndCancelButtons } from "@repo/ui/Buttons/saveAndCancelButtons";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import { SimpleSelect } from "@repo/ui/Select/simpleSelect";
import { useState, type FC } from "react";
import { Can } from "../../../helpers/teammateAuthorizationContext.js";

const modeOptions = [
  {
    label: "Enabled",
    value: InterviewRetakeMode.Unlimited,
  },
  {
    label: "Disabled",
    value: InterviewRetakeMode.Single,
  },
];

interface InterviewRetakeSettingProps {
  mode: InterviewRetakeMode;
  isTrainingProject: boolean;
  onSave: (mode: InterviewRetakeMode) => void;
}

export const InterviewRetakeSetting: FC<InterviewRetakeSettingProps> = ({
  mode,
  isTrainingProject,
  onSave,
}) => {
  const [selectedMode, setSelectedMode] = useState<InterviewRetakeMode>(mode);

  const hasChanges = selectedMode !== mode;
  const label = isTrainingProject ? "Training retakes" : "Interview retakes";
  const description = isTrainingProject
    ? "Enable retakes to allow participants to take their training multiple times, allowing them to practice and learn faster."
    : "Enable retakes to allow participants to take their interview multiple times, allowing them to practice and learn faster.";

  return (
    <Can
      I={PermissionActions.UPDATE}
      a={PermissionSubjects.JOB_OPENINGS}
      passThrough={true}
    >
      {(allowed) => (
        <>
          <div className="space-y-2">
            <div className="w-40">
              <Label size={Size.SMALL} className="mb-2 block">
                {label}
              </Label>
              <SimpleSelect
                value={selectedMode}
                onChange={setSelectedMode}
                options={modeOptions}
                isDisabled={!allowed}
              />
            </div>
            <div className="text-sm text-muted-foreground">{description}</div>

            {hasChanges ? (
              <SaveAndCancelButtons
                onSave={() => {
                  onSave(selectedMode);
                }}
                onCancel={() => {
                  setSelectedMode(mode);
                }}
              />
            ) : null}
          </div>
        </>
      )}
    </Can>
  );
};
